<template>
  <v-app>

    <v-app-bar height="80" elevation="0" class="bg-primary">
      <v-toolbar-title>
        <v-img width="190" height="70" :src="'/images/logowhite.png'"></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <NotifIcon class="mx-3" v-if="useUserStore().loggedIn" />
      <UserProfile class="mx-3" v-if="useUserStore().loggedIn" />
   
    </v-app-bar>
    <v-main class="bg-transparent">
      <NuxtPage />
    </v-main>
    
  <FooterRole/>
   </v-app>
   
</template>

<script>

export default {
  data() {
    return {

    }
  },
  mounted(){
    this.getDetailLatihanPeserta()
  },
  methods: {
    async getDetailLatihanPeserta() {
      const event = useRequestEvent();
      const option = {
        page: 0,
        size: 10,
        sort: 'id,asc',
        nomorId: useUserStore().user.username
      };
      const queryParams = new URLSearchParams(option).toString();
      try {
        const result = await fetchData(
          event,
          "/mgmt/user-mgmt-menu/peserta/paging?" + queryParams
        );
        useUserStore().$patch({
          pengaturan: {
            DataKuisPeserta: result.data[0]
          },
        });

      } catch (error) { }
      this.loading = false;
    },
    
  }
}
</script>

<style>
.home-pelatihan-shape {
  position: absolute;
  z-index: 9999;
  top: 0%;
  left: 35%;
}

.bg_red {
  background: linear-gradient(45deg, #f60, #38adf1);
}

</style>